<section>
  <div>
    <img src="./assets/img/realforce_data.svg" alt="Realforce data platform" />
    <div>
      <p translate>app_discontinue_message</p>
      <p class="sub-text" translate>app_discontinue_sub_message</p>
    </div>
  </div>
</section>
